import AdminBenchmarkPerformanceOverview from './AdminBenchmarkPerformanceOverview';

function AdminBenchmarkPerformanceRun({ data }) {
  return <AdminBenchmarkPerformanceOverview data={data} />;
}

export default AdminBenchmarkPerformanceRun;
